import BigNumber from 'bignumber.js';
import { isNumber } from 'lodash';

export function calculatePercentageDifference(
    newValue: number | null | undefined,
    oldValue: number | null | undefined
) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') {
        return (1 - newValue / oldValue) * 100;
    }
    return null;
}

export function percentageDiscount(discountPct: number, total: number): number {
    const pctBn = new BigNumber(1).minus(new BigNumber(discountPct).dividedBy(100));
    return Number(BigNumber(total).multipliedBy(pctBn).toFixed(2));
}

/**
 * Calculates the percentage of a value based on a total.
 * This function uses BigNumber for precision handling, which helps avoid floating point precision issues.
 * @param value
 * @param total
 * @returns
 */
export function percentageOf(value: number, total: number): number {
    return Number(BigNumber(total).multipliedBy(new BigNumber(value).dividedBy(100)).toFixed(2));
}

/**
 * Safely rounds a number to a specified precision.
 * If the value is null or undefined, it returns the same.
 * It uses BigNumber for precision handling which helps avoid floating point precisions issues when multiplying/rounding/dividing and rounding issues with the toFixed method of strings.
 * @param value The number to round, can be null or undefined.
 * @param precision The number of decimal places to round to, default is 2.
 * @returns The rounded number, or null/undefined if the input was null/undefined.
 */
export function safeRound<T extends number | null | undefined>(value: T, precision = 2): T {
    if (!isNumber(value) || !Number.isFinite(value)) {
        return value;
    }
    // unfortunately returning Number here will cause issues with the generic type T, so we need to use @ts-ignore
    // @ts-ignore
    return Number(BigNumber(value).toFixed(precision));
}
